import { fetch } from '../../api';
import { fetchFeed } from './general';

export async function fetchData(pageNumber, pageSize) {
  const { payload } = await fetch('messages', { query: { pageNumber, pageSize } });
  const { messages, total } = payload;

  const feed = { total };

  return { data: { threads: messages }, feed };
};

export default (from, pageSize = 20, isPaginated = false) => {
  const pageNumber = Math.ceil(from / pageSize) + 1;
  const feed = { id: 'threads', dataType: 'threads', pageNumber, isPaginated };

  return fetchFeed(feed, from === 0, () => fetchData(pageNumber, pageSize));
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/thread.js